import { initializeApp } from "firebase/app";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAOcGwwzNQceTgtam4pFM_6d2BJKfoGJNw",
  authDomain: "kiosk-3d971.firebaseapp.com",
  projectId: "kiosk-3d971",
  storageBucket: "kiosk-3d971.appspot.com",
  messagingSenderId: "992524982052",
  appId: "1:992524982052:web:91a90385905927991805b1",
  measurementId: "G-20XFZP3LPR"
};

const app = initializeApp(firebaseConfig);

export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  }),
});